import React, { useState } from "react";
import MUIDataTable from "mui-datatables";

import DialogoConfirmacionEmisor from "./DialogoConfirmacionEmisor";
import ModalModificarEmisores from "./ModalModificarEmisores";

const TablaEmisores = ({ datosTabla, origen }) => {
  const [itemClicked, setItemClicked] = useState(undefined);

  const columns = [
    {
      name: "codigo",
      label: "Código",
      options: {
        filter: false,
        display: true,
      },
    },

    {
      name: "nombre",
      label: "Nombre ",
      options: {
        filter: false,
        display: true,
      },
    },

    {
      name: "origen",
      label: "Origen",
      options: {
        filter: false,
        display: true,
      },
    },

    {
      name: "id",
      label: " ",
      options: {
        filter: false,
        display: true,
        sort: false,
        viewColumns: false,
        customBodyRenderLite: (value, tableMeta, updateValue) => (
          <DialogoConfirmacionEmisor id={datosTabla[value][3]} />
        ),
      },
    },
  ];

  const options = {
    expandableRowsOnClick: true,
    onPageChange: true,
    responsive: "standard",
    searchPlaceholder: "Buscar ",
    tableBodyHeight: "estándar",
    tableBodyMaxHeight: "estándar",
    onRowsPerPageChange: 10,
    print: false,
    viewColumns: true,
    filter: false,
    selectableRows: "none",
    download: false,
    onRowClick: (e, meta) => {
      handleOpenModal(meta.dataIndex);
    },

    textLabels: {
      body: {
        noMatch: "Registros no encontrados",
        toolTip: "Ordenar",
        columnHeaderTooltip: (column) => `Ordenar por ${column.name}`,
      },
      pagination: {
        next: "Siguiente",
        previous: "Anterior",
        rowsPerPage: "Registros por página:",
        displayRows: "de",
      },
      toolbar: {
        search: "Buscar",
        viewColumns: "Ver columnas",
      },

      viewColumns: {
        title: "Mostrar columnas",
        titleAria: "Mostrar/Esconder columnas",
      },

      TableHead: {
        root: {
          color: "white",
          backgroundColor: "#007B7B",
        },
      },
    },
  };

  const handleOpenModal = (index) => {
    setItemClicked(datosTabla[index]);
  };

  const handleDeleteItemClicked = () => {
    setItemClicked(undefined);
  };

  return (
    <div>
      <MUIDataTable data={datosTabla} columns={columns} options={options} />
      {itemClicked && (
        <ModalModificarEmisores
          onHide={handleDeleteItemClicked}
          nombre={itemClicked[1]}
          origen={itemClicked[2]}
          id={itemClicked[3]}
          listaOrigenes={origen}
          codigo={itemClicked[0]}
        />
      )}
    </div>
  );
};

export default TablaEmisores;
